import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const pickPoliciesAdapter = getAdapter({ idFieldName: 'value' });

const pickPoliciesSlice = createSlice({
  name: 'pickPolicies',
  initialState: pickPoliciesAdapter.getInitialState(),
  reducers: {
    setPickPolicies: (state, { payload: { pickPolicies } }) => {
      pickPoliciesAdapter.setAll(state, pickPolicies);
    },
  },
});

const selectors = pickPoliciesAdapter.getSelectors(({ pickPolicies }) => pickPolicies);

export const getPickPolicies = (state) => selectors.selectAll(state);

export const {
  setPickPolicies,
} = pickPoliciesSlice.actions;

export default pickPoliciesSlice.reducer;
